import { createBrowserHistory } from "history"; // import the createBrowserHistory function from history package

const history = createBrowserHistory(); // create a custom history object

export default history; // export the history object
